import React, { ReactElement } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Sidebar from '../../components/Sidebar'
import { ITemplate } from '../../interfaces/Template'

function DefaultTemplate({ children }: ITemplate): ReactElement {
  return (
    <>
      <Header />
      <div className="containerFluid hFull miw0 defaultTemplate">
        <div className="row hFullMd">
          <Sidebar />
          <div className="colMd9 colLg10">
            <div className="templateContent">{children}</div>
          </div>
        </div>
      </div>
      <Footer showResetButton={true} />
    </>
  )
}

export default DefaultTemplate
